import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  userPlan = "";
  path = location.pathname;
  showMessage = false;
  message = "";
  alertType: number = 1;

  constructor(private authService: SocialAuthService, private router: Router, private userApiService: UserApiService,) {
    router.events.subscribe((val) => {
      // see also
      this.path = location.pathname;
    });
  }

  ngOnInit() {
    this.path = location.pathname;
    
    this.userApiService.getUserSubscriptionPlan().subscribe((response: any) => {
      
      if (response != null && response.plan != null) {
        this.userPlan = response.plan.charAt(0).toUpperCase() + response.plan.slice(1) + " Plan";
      }
      else {
        this.userPlan = "Starter Plan";
      }
    });
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  isLoggedIn() {
    return localStorage.getItem("access_token") == null ? false : true;
  }

  signOut() {
    this.authService.signOut();
    localStorage.removeItem("access_token");
  }

  showAlert(alertType: number, message: string) {
    this.alertType = alertType;
    this.message = message;
    this.showMessage = true;

    setTimeout(() => {
      this.showMessage = false;
      this.message = "";
    }, 5000);
  }

  copyTextToClipboard() {
    
    navigator.clipboard.writeText("support@rankahead.app");

    this.showAlert(1, "Email copied!")

  }
}
